import React, { useState } from 'react';
import { Box, Text } from '@wix/design-system';
import { Collapse, ToggleCollapsibleButton, useCollapse } from '../Collapse';
import { FaqQuestion } from './FaqQuestion';
export const FaqItem = ({ question, answer, isOpen: isOpenByDefault, isFirst, onClickFaqItem, }) => {
    const { isOpen, toggleCollapse } = useCollapse({
        isOpen: !!isOpenByDefault,
    });
    const [isHovering, setIsHovering] = useState(false);
    const faqBorder = '1px solid #DFE5EB';
    const handleFaqClick = () => {
        onClickFaqItem?.({ action: isOpen ? 'close' : 'open', question });
        toggleCollapse();
    };
    return (React.createElement(Box, { direction: "vertical", borderTop: isFirst ? faqBorder : '', borderBottom: faqBorder, padding: "8px 0" },
        React.createElement("div", { onClick: handleFaqClick, onMouseEnter: () => setIsHovering(true), onMouseLeave: () => setIsHovering(false) },
            React.createElement(Box, null,
                React.createElement(FaqQuestion, { question: question }),
                React.createElement(ToggleCollapsibleButton, { visible: true, isOpen: isOpen, skin: "dark", size: "small", iconColor: isHovering ? '#116DFF' : '#000624', iconSize: 35 })),
            React.createElement(Collapse, { isOpened: isOpen },
                React.createElement(Box, { paddingBottom: "13px" },
                    React.createElement(Text, { weight: "normal", size: "medium", tagName: "p" }, answer))))));
};
//# sourceMappingURL=FaqItem.js.map